import { types } from './mutation-types';
import { RepositoryFactory } from '../../../repositories/RepositoryFactory';

const shop = RepositoryFactory.get('user');
const customer = RepositoryFactory.get('customer');

export const cart = {
  namespaced: true,
  // initial state
  // shape: [{ id, quantity }]
  state: {
    checkoutStatus: null,
    deliveries_no: 1,
    userIsGuest: false,
    userIsGuestLoaded: false,
    userId: -1,
    summary: 0,
    grossSummary: '0.00',
    online: false,
    tax: '0.00',
    shippingCost: '0.00',
  },
  getters: {
    getDeliveryNumber: state => state.deliveries_no,
    getUserIsGuest: state => state.userIsGuest,
    getUserIsGuestLoaded: state => state.userIsGuestLoaded,
    getUserId: state => state.userId,
    getOnlinePayment: state => state.online,
    getGrossSummary: state => state.grossSummary,
    getTax: state => state.tax,
    getShippingCost: state => state.shippingCost,
  },
  actions: {
    setDeliveryNumber({ dispatch, commit }, no) {
      let number = no;
      // if (state.deliveries_no === 1 && no > 1) dispatch('delivery/copyDeliveryProducts', [0, 1], { root: true });
      if (no > 10) { number = 10; }

      if (no > 0) commit(types.SET_DELIVERY_NUMBER, number);
      // if (no >= 2) commit(types.SET_DELIVERY_NUMBER, no + 1);

      dispatch('delivery/initDelivery', no, { root: true });
      dispatch('delivery/removeDelivery', no, { root: true });
    },
    async setUserIsGuest({ dispatch, commit }) {
      try {
        const isGuestResponse = await shop.isGuest();
        commit(types.SET_USER_IS_GUEST, isGuestResponse.data);

        if (isGuestResponse.data.isGuest !== false) {
          return;
        }

        const invoiceDataResponse = await customer.getCustomerInvoiceData();
        const invoiceData = invoiceDataResponse.data;
        await dispatch('fvForm/setFromBackend', invoiceData, { root: true });

        if (window.sessionStorage.reorder) return;

        await dispatch('contactPerson/handleNameChange', invoiceData.firstname, { root: true });
        await dispatch('contactPerson/handleSurnameChange', invoiceData.lastname, { root: true });
        await dispatch('contactPerson/handleEmailChange', invoiceData.useremail, { root: true });
        await dispatch('bankNumber/handleAccountNumberChange', invoiceData.account, { root: true });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error.message);
      }
    },
    setSummary({ commit, rootGetters }) {
      commit(types.SET_SUMMARY, rootGetters['delivery/getTotal'].summary);
    },
    setGrossSummary({ commit }, value) {
      commit(types.SET_GROSS_SUMMARY, value);
    },
    setOnline({ commit }, value) {
      commit(types.SET_ONLINE, value);
    },
    setTax({ commit }, value) {
      commit(types.SET_TAX, value);
    },
    setShippingCost({ commit }, value) {
      commit(types.SET_SHIPPING_COST, value);
    },
    reset({ commit }) {
      commit(types.RESET);
    },
    hydrate({ commit }, state) {
      commit(types.HYDRATE, state);
    },
  },
  mutations: {
    [types.SET_DELIVERY_NUMBER](state, no) {
      state.deliveries_no = no;
    },
    [types.SET_USER_IS_GUEST](state, response) {
      state.userIsGuestLoaded = true;
      state.userIsGuest = response.isGuest;
      state.userId = response.userId;
    },
    [types.SET_SUMMARY](state, total) {
      state.summary = total;
    },
    [types.SET_GROSS_SUMMARY](state, grossTotal) {
      state.grossSummary = grossTotal;
    },
    [types.SET_ONLINE](state, value) {
      state.online = value;
    },
    [types.SET_TAX](state, tax) {
      state.tax = tax;
    },
    [types.SET_SHIPPING_COST](state, shippingCost) {
      state.shippingCost = shippingCost;
    },
    [types.RESET](state) {
      state.checkoutStatus = null;
      state.deliveries_no = 1;
      state.userIsGuest = false;
      state.userId = -1;
      state.summary = 0;
      state.grossSummary = '0.00';
      state.online = false;
      state.tax = '0.00';
      state.shippingCost = '0.00';
    },
    [types.HYDRATE](state, payload = {}) {
      const isPaymentOnline = payload.online || false;
      const deliveryPointsCount = payload.deliveries_no || 1;
      state.online = isPaymentOnline;
      state.deliveries_no = deliveryPointsCount;
    },
  },
};
